import type { ServiceRequest } from "bonusx-api-main-manager";
import type { responseInterface } from "swr";
import useSWR from "swr";
import { useIsLogged } from "../../hooks/auth/use-is-logged/use-is-logged";
import { swrBaseConfig } from "../common/swrBaseConfig";
import { serviceRequestLegacyApi } from "../services/service-request-api-instance";
import { useAbility } from "./useAbilityRules";

function fetcher(practiceId: number) {
  return serviceRequestLegacyApi.getServiceRequestById(practiceId);
}

async function revalidate(response: responseInterface<ServiceRequest, any>, practiceId: number) {
  const data = await fetcher(practiceId);
  return await response.mutate(data);
}

/**
 * @deprecated this hook use v1 legacy api
 */
export function useLegacyServiceRequestApi(practiceId: number) {
  const isLogged = useIsLogged();
  const abilityRules = useAbility();
  const abilited = abilityRules.can("readOne", "ServiceRequest");
  const skip = !isLogged || !abilited;

  const LEGACY_SERVICE_REQUEST_API_KEY = `serviceRequestLegacyApi-getServiceRequestById-${practiceId}`;

  const response = useSWR(skip ? null : LEGACY_SERVICE_REQUEST_API_KEY, () => fetcher(practiceId), {
    ...swrBaseConfig,
    dedupingInterval: 0,
  });

  const serviceRequest: ServiceRequest | undefined = response.data?.data;

  return {
    serviceRequest,
    revalidate: revalidate.bind(null, response, practiceId),
    loading: response.isValidating || (!response.error && !response.data),
    error: response.error,
  };
}
